module.exports = __webpack_public_path__ + "img/404.bf515103.png";